// extracted by mini-css-extract-plugin
export default {"container":"apply_container__kPyVC","bg_container":"apply_bg_container__-CK5Q","form_container":"apply_form_container__wz+-k","title":"apply_title__SN1kh"};